import { render, staticRenderFns } from "./ListDatasources.vue?vue&type=template&id=494e8ff6&"
import script from "./ListDatasources.vue?vue&type=script&lang=js&"
export * from "./ListDatasources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports